export default __webpack_public_path__ + "static/media/FoundersGrotesk-Regular.65edf975.woff2";